"use strict";
/**
 * TooltipComponent
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var crude_selector_1 = require("../../../store/crude/crude.selector");
var Help_1 = __importDefault(require("@mui/icons-material/Help"));
var Lightbulb_1 = __importDefault(require("@mui/icons-material/Lightbulb"));
var HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
var HelpCenter_1 = __importDefault(require("@mui/icons-material/HelpCenter"));
var Info_1 = __importDefault(require("@mui/icons-material/Info"));
var TooltipComponent_1 = __importDefault(require("./TooltipComponent"));
var styles_1 = require("@mui/styles");
var react_redux_1 = require("react-redux");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    tooltipIcon: {
        cursor: 'pointer',
        margin: '0 0 0 5px',
    },
    tooltipContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
    },
}); });
var LabelWithTooltipComponent = function (props) {
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var classes = useStyles();
    var getIcon = function (param) {
        switch (param) {
            case 'help':
                return react_1.default.createElement(Help_1.default, { className: classes.tooltipIcon });
            case 'lightbulb':
                return react_1.default.createElement(Lightbulb_1.default, { className: classes.tooltipIcon });
            case 'helpOutline':
                return react_1.default.createElement(HelpOutline_1.default, { className: classes.tooltipIcon });
            case 'helpCenter':
                return react_1.default.createElement(HelpCenter_1.default, { className: classes.tooltipIcon });
            case 'info':
                return react_1.default.createElement(Info_1.default, { className: classes.tooltipIcon });
            default:
                return null;
        }
    };
    var _a = react_1.useState(null), tooltipIcon = _a[0], setTooltipIcon = _a[1];
    react_1.useEffect(function () {
        var _a, _b;
        ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.tooltipIcon) && setTooltipIcon(getIcon((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.tooltipIcon));
    }, [appLayout]);
    return (react_1.default.createElement("div", { className: classes.tooltipContainer },
        react_1.default.createElement("span", { className: props.className }, props.label),
        props.description && tooltipIcon &&
            react_1.default.createElement(TooltipComponent_1.default, { title: props.description, element: tooltipIcon })));
};
exports.default = LabelWithTooltipComponent;
